import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import { InputLabel, FormHelperText } from '@material-ui/core';
import { FieldSet } from 'root/globals/Form';
import TimePicker from 'rc-time-picker';
import CustomFormInput from './CustomFormInput';
import moment from 'moment';
import 'rc-time-picker/assets/index.css';

export default class CustomTimePicker extends CustomFormInput {
    constructor(props) {
        super(props);
        
        this.state = { isFocused: false };
    }
    
    getSupportedProps() {
        return {...super.getSupportedProps(), ..._.filterSupportedProps(this.props, {format: true, showSecond: true, defaultOpenValue: true, minuteStep: true, minTime: true, maxTime: true, popupStyle: true})};
    }
    
    getElement() {
        let props           = this.getSupportedProps();
        props.format        = props.format || 'HH:mm';
        props.showSecond    = typeof props.showSecond == 'undefined' ? false : props.showSecond;
        props.onOpen        = () => this.setState({isFocused: true});
        props.onClose       = () => this.setState({isFocused: false});

        if(!_.is_empty(props.value))
            props.value = moment(props.value, props.format);
        else
            props.value = null;

        return <TimePicker id={this.props.field} focusOnOpen={true} getPopupContainer={node => node} allowEmpty={(this.props.mandatory ? false : true)} onChange={this._onChange} {...props} />;
    }
    
    _onChange(value) {
        if(value)
            this.props.onChangeText(value.format('HH:mm') + ':00');
        else
            this.props.onChangeText(null);
    }
}

CustomTimePicker.defaultProps = {
    defaultOpenValue: moment('1985-12-31 00:00:00')
}